import {Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {BaseListComponent} from "../base-list/base-list.component";
import {EFilterType, ITableConfig} from "../../../interface/table.config";
import {CrudService} from "../service/crud.service";
import {ICrudRes} from "../../../interface/http.config";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {CrudListModel} from "../../../model/crud-list.model";
import {ECrudFilterType} from "../../../interface/crud.filter-type.enum";

@Component({
  selector: 'app-manager-role',
  standalone: true,
  imports: [
    TemplateComponent,
    BaseListComponent,
    NgIf
  ],
  templateUrl: './manager-role.component.html',
  styleUrl: './manager-role.component.scss'
})
export class ManagerRoleComponent extends CrudListModel implements OnInit {

  override editLink = '/dashboard/manager-role-edit/';
  override addLink = '/dashboard/manager-role-create';

  constructor(crudService: CrudService,
              router: Router) {

    super(crudService, router);


    this.crudService.setProvider('manager-role');
  }

  protected tableConfig: ITableConfig = {
    cells: [
      {
        header: 'id',
        field: 'id',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'name',
        field: 'name',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'Settings',
        field: 'settings',
        sortable: false,
        filterType: EFilterType.NONE,
        value: (item) => {
          return 'JSON';
        },
      },
    ],
    actions: [
      'edit',
      'delete',
    ]
  };

  ngOnInit() {
    this.update();
  }
}
